
import axios from "./axios";

const SubscriptionService = {
  getPriceTier: async () => {
    try {
      const response = await axios.get(`/price-tiers`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  }
};
export default SubscriptionService;